module.exports = __webpack_public_path__ + "static/media/custom-ex-18.0631fa41.jpg";